// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const Google1 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_11301_324)">
      <path
        d="M48.0004 24.538C48.0004 22.8362 47.8446 21.1998 47.5552 19.6289H24.4902V28.9235H37.6702C37.0913 31.9125 35.3548 34.4435 32.75 36.1453V42.1889H40.698C45.3288 37.9998 48.0004 31.8471 48.0004 24.538Z"
        fill="#4285F4"
      />
      <path
        d="M24.4897 47.9924C31.1019 47.9924 36.6455 45.8542 40.6975 42.1888L32.7494 36.1451C30.5676 37.5851 27.7847 38.4579 24.4897 38.4579C18.1223 38.4579 12.7123 34.2469 10.7754 28.5742H2.62695V34.7706C6.65664 42.6033 14.9164 47.9924 24.4897 47.9924Z"
        fill="#34A853"
      />
      <path
        d="M10.7755 28.5527C10.2857 27.1127 9.99629 25.5854 9.99629 23.9927C9.99629 22.4 10.2857 20.8727 10.7755 19.4327V13.2363H2.62709C0.957328 16.4654 0 20.1091 0 23.9927C0 27.8763 0.957328 31.52 2.62709 34.7491L8.97217 29.9054L10.7755 28.5527Z"
        fill="#FBBC05"
      />
      <path
        d="M24.4897 9.54855C28.0963 9.54855 31.3023 10.7704 33.8626 13.1267L40.8756 6.25401C36.6232 2.37037 31.1019 -0.0078125 24.4897 -0.0078125C14.9164 -0.0078125 6.65664 5.38128 2.62695 13.2358L10.7754 19.4322C12.7123 13.7595 18.1223 9.54855 24.4897 9.54855Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_11301_324">
        <rect width="48" height="48" fill="white" transform="translate(0 -0.0078125)" />
      </clipPath>
    </defs>
  </svg>
);
